import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../styles/CustomButton.css';
import { load } from '../../redux/actions/loader.action';
import Preloader from './Preloader';

function CustomButtonUpload({
  text,
  color,
  colorText,
  className,
  SvgIcon,
  styleSvg,
  fileName,
  name,
  uploadFileFunc,
  isDispatch = true,
  currentFolder,
  ...rest
}) {
  const loader = useSelector((state) => state.loader);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  const buttonStyle = {
    backgroundColor: color,
    color: colorText,
    padding: '10px 20px',
    border: 'none',
    cursor: 'pointer',
  };
  // Функция для отправки файла на сервер
  const handleFileUpload = (event) => {
    event.preventDefault();
    // Переводим в состояние загрузки
    dispatch(load());

    const file = event.target.files[0];
    if (!file) return;

    // формируем данные для отправки на сервер
    const parentId = currentFolder?.id || null;
    const formData = new FormData();
    formData.append(fileName, file);
    formData.append('parentId', parentId);
    if (isDispatch) {
      dispatch(uploadFileFunc(formData, file.name));
    }
    if (!isDispatch) {
      uploadFileFunc(formData, file.name);
    }
    // Сброс значения input для обработки файлов с тем же именем
    event.target.value = '';
  };

  // Функция для открытия окна выбора файла
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="upload-btn-wrap">
      <Preloader isLoading={loader?.isLoading} />
      <button
        {...rest}
        className={`custom-btn ${className ? className : ''}`}
        style={buttonStyle}
        onClick={handleButtonClick}
      >
        {SvgIcon && <SvgIcon style={{ verticalAlign: 'middle', marginRight: '8px', ...styleSvg }} />}
        {text}
      </button>
      <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileUpload} />
    </div>
  );
}

export default CustomButtonUpload;
